<app-page-content>
    <div class="row">
        <div class="col-4">
            <ng-container *ngTemplateOutlet="dashCard; context: {
                header: 'Active Surveys',
                icon: 'progress',
                count: activeConductList?.length
            }"></ng-container>
            <dx-pie-chart id="pie1"  palette="soft" [dataSource]="activePieChartData">
                <dxi-series argumentField="name" valueField="count">
                    <dxo-label [visible]="true">
                        <dxo-connector [visible]="true" [width]="1"></dxo-connector>
                    </dxo-label>
                </dxi-series>
            </dx-pie-chart>
    
        </div>
        <div class="col-8">
            <app-data-grid [config]="config" [dataSource]="activeConductList"></app-data-grid>
        </div>
    </div>
</app-page-content>

<app-page-content>
    <div class="row">
        <div class="col-4">
            <ng-container *ngTemplateOutlet="dashCard; context: {
                header: 'Completed Surveys',
                icon: 'completed',
                count: completedConductList?.length
            }"></ng-container>
            <dx-pie-chart id="pie2"  palette="soft" [dataSource]="completedPieChartData">
                <dxi-series argumentField="name" valueField="count">
                    <dxo-label [visible]="true">
                        <dxo-connector [visible]="true" [width]="1"></dxo-connector>
                    </dxo-label>
                </dxi-series>
            </dx-pie-chart>
    
        </div>
        <div class="col-8">
            <app-data-grid [config]="config" [dataSource]="completedConductList"></app-data-grid>
        </div>
    </div>
</app-page-content>

<ng-template #dashCard let-header="header" let-icon="icon" let-count="count">
    <div class="dash-card mb-2">

        <div class="dash-header">
            {{header}}
        </div>
        <div class="dash-content">{{count ?? 0}}</div>
        <i *ngIf="icon == 'progress'" class="dash-icon fa fa-spinner" style="color: yellow"></i>
        <i *ngIf="icon == 'completed'" class="dash-icon fa fa-check" style="color: green"></i>
    </div>
</ng-template>